define('views/microshop-orders-view',[
  'jquery',
  'utils/view',
  'utils/toast',
  'connections/microshop-connection',
  'settings',

  'modules/pop-over'
], function ($, View, toast, MicroshopConnection, settings, PopOver) {
  var _this;
  var MicroshopOrdersView = (function () {
    function MicroshopOrdersView($container) {
      _this = this;
      _this.container = $container;
      _this.shopId = $container.data('shopId');
    }

    MicroshopOrdersView.prototype.init = function () {
      _this.container.find('[data-pending-check]').on('click', function (e) {
        e.stopPropagation();
      });

      _this.container.find('[data-pending-order]').on('click', function () {
        window.location.href = $(this).data('url');
      });

      _this.bindCheckAll();
      _this.bindRemovePendingOrders();
      _this.bindCreateMaster();

      _this.bindRemoveMasterOrder();
      _this.bindViewMasterOrder();
    };

    MicroshopOrdersView.prototype.bindViewMasterOrder = function () {
      $('[data-action="viewMasterOrder"]').on('click', function () {
        window.location.href = $(this).data('url');
      });
    };

    MicroshopOrdersView.prototype.bindCheckAll = function () {
      $('[data-check-all]').on('change', function () {
        var isChecked = $(this).is(':checked');
        var $checkboxes = _this.container.find('input[name="order-checkbox"]');

        $checkboxes.each(function () {
          $(this).prop('checked', isChecked);
        });
      });
    };

    MicroshopOrdersView.prototype.bindRemoveMasterOrder = function () {
      var $popupTemplate = $('#micro-orders-popup');
      _this.removePopOver = new PopOver($(document), $popupTemplate);
      var $confirmButton = $('[data-popup-confirm]');

      function unBindPopup() {
        $confirmButton.off('click');
      }

      $('[data-action="removeMasterOrder"]').on('click', function (e) {
        e.stopPropagation();
        var orderId = $(this).data('id');

        $confirmButton.on('click', function (e) {
          _this.removePopOver.hide(unBindPopup);
          MicroshopConnection.removeMasterOrder(_this.shopId, orderId).then(function () {
            location.reload();
          });
        });

        _this.removePopOver.show($(this), unBindPopup);
      });
    };

    MicroshopOrdersView.prototype.bindRemovePendingOrders = function () {
      var $popupTemplate = $('#micro-orders-popup');
      _this.removeOnePopOver = new PopOver($(document), $popupTemplate);
      _this.removeManyPopOver = new PopOver($(document), $popupTemplate);
      var $confirmButton = $('[data-popup-confirm]');

      function removeOrders(orderIds) {
        if (!orderIds.length) return;
        MicroshopConnection.removePendingOrders(_this.shopId, orderIds).then(function (resData, __, req) {
          if (req.status === 200) {
            toast.queue(req.statusText, 5000);

            $('[data-pending-order]').each(function () {
              if (orderIds.indexOf($(this).data('pendingOrder')) !== -1) {
                $(this).remove();
              }
            });
          }
        });
      }

      function unBindPopup() {
        $confirmButton.off('click');
      }

      $('[data-action="removeOrder"]').on('click', function (e) {
        e.stopPropagation();
        var orderId = $(this).data('id');

        $confirmButton.on('click', function (e) {
          _this.removeOnePopOver.hide(unBindPopup);
          removeOrders([orderId]);
        });

        _this.removeOnePopOver.show($(this), unBindPopup);
      });

      $('[data-action="removeOrders"]').on('click', function (e) {
        e.stopPropagation();

        var $checkboxes = _this.container.find('input[name="order-checkbox"]:checked');
        var orderIds = $checkboxes
          .map(function () {
            return +$(this).val();
          })
          .get();

        $confirmButton.on('click', function (e) {
          _this.removeManyPopOver.hide(unBindPopup);
          removeOrders(orderIds);
        });

        _this.removeManyPopOver.show($(this), unBindPopup);
      });
    };

    MicroshopOrdersView.prototype.bindCreateMaster = function () {
      $('[data-action="createMasterOrder"]').on('click', function (e) {
        e.stopPropagation();
        var $checkboxes = _this.container.find('input[name="order-checkbox"]:checked');
        var orderIds = $checkboxes
          .map(function () {
            return $(this).val();
          })
          .get();

        if (!orderIds.length) return;

        MicroshopConnection.createMasterOrder(_this.shopId, orderIds).then(function (res) {
          if (res.orderId) {
            window.location.href = settings.cartPageUrl + 'order?order=' + res.orderId;
          }
        });
      });
    };

    return MicroshopOrdersView;
  })();

  return View('MicroshopOrdersView', function () {
    var view = new MicroshopOrdersView($('[data-view="MicroshopOrdersView"]'));
    view.init();
  });
});

